import Request from "@services/request";
import { IGetAllFormData, IGetSingleFormData } from "./types";

const GetAllWithoutFilter = async () =>
    await new Request().get<IReturnValue<Array<ITags["get"]>>>("TAGS_ALL");

const GetAll = async ({ query, page }: IGetAllFormData) =>
    await new Request().get<IReturnValue<Array<ITags["get"]>>>("TAGS", {
        params: {
            query,
            page,
        },
    });

const GetSingle = async ({ id }: IGetSingleFormData) =>
    await new Request().get<IReturnValue<ITag["get"]>>({
        base: "TAG",
        params: {
            id,
        },
    });

const Create = async ({
    faName,
    enName,
    seoName,

    url,
    description,
    seoDescription,
    seoKeywords,
}: ITags["post"]) =>
    await new Request().post<ITags["post"], IReturnValue<any>>("TAGS", {
        faName,
        enName,
        seoName,
        url,
        description,
        seoDescription,
        seoKeywords,
    });

const Edit = async ({
    id,
    faName,
    enName,
    seoName,
    url,
    description,
    seoDescription,
    seoKeywords,
}: ITag["put"]) =>
    await new Request().put<Omit<ITag["put"], "id">, IReturnValue<any>>(
        {
            base: "TAG",
            params: {
                id,
            },
        },
        {
            faName,
            enName,
            seoName,
            url,
            description,
            seoDescription,
            seoKeywords,
        },
    );

const Delete = async ({ id }: ITag["delete"]) =>
    await new Request().delete<IReturnValue<any>>({
        base: "TAG",
        params: {
            id,
        },
    });

const UploadFile = async ({ id, file }: { id: number; file: File }) => {
    const formData = new FormData();

    formData.append("image", file);

    return await new Request().post<
        FormData,
        IReturnValue<{
            url: string;
        }>
    >(
        {
            base: "TAG_IMAGE",
            params: {
                id,
            },
        },
        formData,
    );
};

const DeleteImage = async ({ id }: ITag["delete"]) =>
    await new Request().delete<IReturnValue<any>>({
        base: "TAG_IMAGE",
        params: {
            id,
        },
    });

const SetMain = async ({ id }: { id: number }) =>
    await new Request().post<{}, IReturnValue<any>>(
        {
            base: "TAG_MAIN",
            params: {
                id,
            },
        },
        {},
    );

// Main Object
const TagsApis = {
    GetAllWithoutFilter,
    GetAll,
    GetSingle,
    Create,
    Edit,
    Delete,
    UploadFile,
    DeleteImage,
    SetMain,
};

export default TagsApis;
